import React from "react";

import { appConstants } from "../../config/app-constants";

type Props = {};

const GrossSalaryHint: React.FC<Props> = (props: Props) => {
	return (
		<>
			<section className="mb-4">
				<h5 className="text-start">1.Gross Salary and its breakup:</h5>
				<p className="leading-para text-greyDark">
					Gross salary is the aggregate amount of compensation discharged by an employer or company
					towards the employment of an employee.
				</p>
				<p className="leading-para text-greyDark">
					You can find Gross Salary and its breakup(Salary as per section 17(1), Value of
					perquisites under section 17(2) and Profits in lieu of salary under section 17(3)) from
					the Form-16 Part B which your employer would have emailed you. You can upload your Form-16
					and we will auto-read these information.
				</p>
				<img
					src={`${appConstants.basePath}/assets/images/hints/gross-salary-001.png`}
					alt="salary"
					className="img-fluid d-block mx-auto my-4"
				/>
				<p className="leading-para text-greyDark">
					Don’t worry if you don’t have Form-16, you can ask your HR for the same or else you can
					get these details from your salary slip.
				</p>
			</section>
			<section className="mb-4">
				<h5 className="text-start">1(a)Salary as per section 17(1)</h5>
				<p className="leading-para text-greyDark">
					You can obtain the Salary as per section 17(1) from the Form-16 Part B(just below Gross
					Salary section).
				</p>
				<p className="leading-para text-greyDark">
					If your tax return is ITR-2 or ITR-3, it is mandatory to declare the breakup of "Salary as
					per section 17(1)" for your returns to get processed. You can find this information under
					the annexure section of Form-16. You can enter each component by clicking "+Add more
					items". You can select a label from the drop-down or type it as per your Form-16.
				</p>
				<img
					src={`${appConstants.basePath}/assets/images/hints/gross-salary-002.png`}
					alt="salary"
					className="img-fluid d-block mx-auto my-4"
				/>
				<p className="leading-para text-greyDark">
					Don’t worry if you don’t have Form-16, you can ask your HR for the same or else you can
					get these details from your salary slip.
				</p>
			</section>
			<section className="mb-4">
				<h5 className="text-start">2.Exempt allowances under section 10</h5>
				<p className="leading-para text-greyDark">
					You can obtain this information from the Form-16 Part B, under the head-"Less:Allowances
					to the extent exempt under section 10" .
				</p>
				<img
					src={`${appConstants.basePath}/assets/images/hints/gross-salary-003.png`}
					alt="salary"
					className="img-fluid d-block mx-auto my-4"
				/>
				<p className="leading-para text-greyDark">
					If your tax return is ITR-2 or ITR-3, it is mandatory to declare the breakup of "Exempt
					allowances under section 10" for your returns to get processed. You can enter each
					component by clicking "+Add more items". You can select a label from the drop-down or type
					it as per your Form-16.
				</p>
			</section>
			<section className="mb-4">
				<h5 className="text-start">HRA Exemption</h5>
				<p className="leading-para text-greyDark">
					Salaried individuals living in rented houses (paying rent) can claim the House Rent
					Allowance (HRA). If you do not live in rented accommodation, this allowance is fully
					taxable.
				</p>
				<p className="leading-para text-greyDark">
					To claim the HRA exemption, HRA must be part of your salary. If your employer does not
					provide you the HRA or if you are self employed, then you can claim the deduction under
					section 80GG.
				</p>
				<p className="leading-para text-greyDark">
					The amount of rent paid cannot be claimed as HRA Exemption directly. The HRA exemption
					shall be lower of the below 3 amounts:
				</p>
				<ol>
					<li>Actual HRA received;</li>
					<li>
						50% of [Basic Salary + Dearness Allowance] for those living in metro cities (40% for
						non-metros);or
					</li>
					<li>Actual rent paid less 10% of [Basic Salary + Dearness Allowance]</li>
				</ol>
				<p className="leading-para text-greyDark">
					You can use the HRA Calculator to calculate the HRA exemption amount.
					<br />
					Note: If you see any auto populated amount under HRA exemption, then it is captured from
					the form-16 that you have uploaded.
				</p>
				<img
					src={`${appConstants.basePath}/assets/images/hints/gross-salary-004.png`}
					alt="salary"
					className="img-fluid d-block mx-auto my-4"
				/>
			</section>
		</>
	);
};

export default GrossSalaryHint;
